import { eventGroup } from '@ngrx/signals/events';
import { type } from '@ngrx/signals';
import type {
  SigningInvitePage,
  SigningInviteAccepted,
  SigningInviteRedeem,
} from '../../schemas/generated/vantage-api.schemas';

/**
 * The public signing-invite flow (`/public/v1/signing-invites`, Decision J6): look an emailed
 * token up to render the signing page, then redeem it — one transaction that spends the invite
 * and accepts the quote it is bound to.
 *
 * Failures carry the backend `code` beside the message because the page must tell three refusals
 * apart: a dead link (`SIGNING_INVITE_INVALID` — invalid, expired, revoked and already-spent all
 * deliberately look alike), a quote that changed mid-review (`QUOTE_REVIEW_CHANGED` — reload and
 * re-review, the terms moved), and everything else.
 */
export const signingInviteEvents = eventGroup({
  source: 'SigningInvite',
  events: {
    lookup: type<string>(),
    lookupSuccess: type<SigningInvitePage>(),
    lookupFailed: type<{ message: string; code: string | null }>(),
    redeem: type<SigningInviteRedeem>(),
    redeemSuccess: type<SigningInviteAccepted>(),
    redeemFailed: type<{ message: string; code: string | null }>(),
  },
});
